module.exports = __webpack_public_path__ + "static/media/rinascimento-logo.3054462d.svg";